module.exports = __webpack_public_path__ + "img/esterilizacion_mobile.67d3db18.png";